var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "        <li class=\"sda-property-search-item\" data-uuid=\""
    + alias2(alias1((depth0 != null ? depth0.brandUuid : depth0), depth0))
    + "\" data-type=\""
    + alias2(alias1((depth0 != null ? depth0.type : depth0), depth0))
    + "\" data-name=\""
    + alias2(alias1((depth0 != null ? depth0.url : depth0), depth0))
    + "\">\n            <img src=\""
    + alias2(alias1((depth0 != null ? depth0.imageUrl : depth0), depth0))
    + "\" class=\"sda-property-img\">\n            <div>\n                <span class=\"sda-property-url\">"
    + alias2(alias1((depth0 != null ? depth0.url : depth0), depth0))
    + "</span>\n                <span class=\"sda-property-location\">"
    + alias2(alias1((depth0 != null ? depth0.city : depth0), depth0))
    + ", "
    + alias2(alias1((depth0 != null ? depth0.state : depth0), depth0))
    + "</span>\n            </div>\n        </li>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<ul>\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</ul>";
},"useData":true});